import type { MetaEventName, MetaMappedEvent } from "./types"

interface MetaEventMapEntry {
  metaEventName: MetaEventName
  requiresExplicitEventId?: boolean
}

const META_EVENT_MAP = {
  search: { metaEventName: "Search", requiresExplicitEventId: true },
  view_item: { metaEventName: "ViewContent" },
  add_to_cart: { metaEventName: "AddToCart", requiresExplicitEventId: true },
  sign_up: { metaEventName: "CompleteRegistration", requiresExplicitEventId: true },
  loan_application_approved: { metaEventName: "InitiateCheckout", requiresExplicitEventId: true },
  purchase: { metaEventName: "Purchase", requiresExplicitEventId: true },
} satisfies Record<MetaMappedEvent, MetaEventMapEntry>

export function getMetaEventMapEntry(event: string): MetaEventMapEntry | undefined {
  return META_EVENT_MAP[event as MetaMappedEvent]
}
